/**
 * Autogenerated file don't modify
 */
(function () {
(function () {
    'use strict';

    var moyaToggle = MoyaContainer.get('core.toggle');
    MoyaComponents.register('site.searchToggle', function (el) {
        var searchForm = document.querySelector('#' + el.getAttribute('aria-controls'));
        var dialogClose = document.querySelector(el.dataset.dialogClose);
        var toggle = moyaToggle.create(el, searchForm, 'searchbox', {
            closeOthers: true,
            onOpen: function () {
                var q = document.querySelector('#q');
                if (q instanceof HTMLElement) {
                    q.focus();
                }
            },
        });
        if (dialogClose) {
            dialogClose.addEventListener('click', function () {
                toggle.close();
            });
        }
        reverseChildren(searchForm.querySelector('.results .wrap'));
        function reverseChildren(parent) {
            for (var i = 1; i < parent.childNodes.length; i++) {
                parent.insertBefore(parent.childNodes[i], parent.firstChild);
            }
        }
    });

}());
typeof tsBuild === 'function' && tsBuild();})();
